export default __webpack_public_path__ + "static/Continuous Integration 8-71d4a7ec8d6447167294a17d56f685e7.png";